import type { CSSProperties } from 'react';

import { getBackgroundColor } from '../utils/background';
import { cn } from '../utils/cn';

import { DROPDOWN_PORTAL_ID } from './DropdownContext.constants';
import * as styles from './Navbar.css';
import type { NavbarMenuElementProps } from './Navbar.type';
import { NAVBAR_MENU_DEFAULTS } from './NavbarMenu.constants';
import { NavbarMenuBurgerProvider } from './NavbarMenuBurger';

export function NavbarMenu(props: NavbarMenuElementProps) {
  const { element, children, className, screen, attributes } = props;
  const {
    background,
    box_shadow,
    style,
    customAttributes,
    gap,
    stickToTop,
    borderWidth,
    borderStyle,
    borderColor,
    borderRadius,
    blurBackground,
  } = element.attrs || {};

  const boxShadows = {
    default: NAVBAR_MENU_DEFAULTS.defaultBoxShadow,
    border: NAVBAR_MENU_DEFAULTS.borderBoxShadow,
    shadow: NAVBAR_MENU_DEFAULTS.shadowBoxShadow,
  };

  const borderStyles =
    style === 'border'
      ? {
          borderColor: borderColor ?? NAVBAR_MENU_DEFAULTS.borderBorderColor,
          borderWidth: borderWidth ?? NAVBAR_MENU_DEFAULTS.borderBorderWidth,
          borderStyle: borderStyle ?? NAVBAR_MENU_DEFAULTS.borderBorderStyle,
        }
      : ({} as CSSProperties);

  return (
    <NavbarMenuBurgerProvider>
      <div id={`${DROPDOWN_PORTAL_ID}-${screen}`} className={styles.navbarMenuDropdownPortal} data-sticky="true" />
      <nav
        {...props}
        defaultValue="221"
        role="presentation"
        {...customAttributes}
        className={cn(
          className,
          customAttributes?.className,
          styles.navbarMenu,
          stickToTop ? styles.navbarMenuSticky : styles.navigationMenuRelative,
          styles.navbarMenuDefaultBackground,
          // blurBackground ? styles.navbarMenuBlurBackground : styles.navbarMenuDefaultBackground, PUNTING THIS FOR NOW
        )}
        style={
          {
            width: '100%',
            ...borderStyles,
            '--box-shadow':
              box_shadow ?? boxShadows[(style as keyof typeof boxShadows) || 'default'] ?? boxShadows.default,
            '--gap': gap ?? NAVBAR_MENU_DEFAULTS.gap,
            '--background': getBackgroundColor(background ?? NAVBAR_MENU_DEFAULTS.background),
            '--border-radius': borderRadius ?? NAVBAR_MENU_DEFAULTS.borderRadius,
            flexDirection: 'column',
            '--blur-background': blurBackground ?? NAVBAR_MENU_DEFAULTS.blurBackground,
          } as CSSProperties
        }
        {...attributes}
      >
        {children}
      </nav>
    </NavbarMenuBurgerProvider>
  );
}
